import React, { TransitionEvent, useRef } from 'react';

import { useCollapse } from '@r1-frontend/ui-react/components/CollapsibleBlock/useCollapsed';

import * as ST from './styled';

interface IProps {
    children: React.ReactNode,
    isOpen?: boolean,
    onTransitionEndHandler?: (e: TransitionEvent) => void,
    className?: string,
    duration?: string,
}

export const CollapsibleBlock = ({
    isOpen,
    onTransitionEndHandler,
    className,
    children,
    duration = '0.3s',
}: IProps) => {
    const content = useRef<HTMLDivElement>(null);
    const { setIsExpandedStyle, setIsCollapsedStyle, style } = useCollapse({
        isOpen,
        content,
    });

    const onTransitionEnd = (e: TransitionEvent) => {
        if (e.target === content.current && e.propertyName === 'height') {
            isOpen ? setIsExpandedStyle() : setIsCollapsedStyle();

            if (onTransitionEndHandler) {
                onTransitionEndHandler(e);
            }
        }
    };

    return (
        <ST.CollapseWrapper
            ref={content}
            style={style}
            duration={duration}
            className={className}
            onTransitionEnd={onTransitionEnd}
            data-test={'AccordionBody'}
        >
            {children}
        </ST.CollapseWrapper>
    );
};
